import React, { useEffect, useRef } from 'react';
import { DIMENSION_NAMES } from '../../utils/constants';

export default function SurveyScreen({
  question,
  questionIndex,
  totalQuestions,
  selectedIndex,
  onSelectAnswer,
  onRewindSection,
  onBack,
  effectiveDimension,
}) {
  const dimLabel = question.dimension_id ? DIMENSION_NAMES[question.dimension_id] : null;
  const screenRef = useRef(null);

  // Scroll question into view on each question change
  useEffect(() => {
    if (screenRef.current) {
      screenRef.current.scrollIntoView({ behavior: 'instant', block: 'start' });
      window.scrollBy(0, -16);
    }
  }, [questionIndex]);

  return (
    <div className="view on" data-testid="survey-screen" ref={screenRef}>
      {dimLabel && (
        <div className="label" style={{ marginBottom: '16px', color: 'var(--teal)' }}>
          {dimLabel.toUpperCase()}
        </div>
      )}

      <h2 style={{ marginBottom: '24px', fontWeight: 400 }}>{question.question_text}</h2>

      {question.response_options.map((option) => (
        <div
          key={option.index}
          className={`option-card ${selectedIndex === option.index ? 'selected' : ''}`}
          onClick={() => onSelectAnswer(option.index)}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onSelectAnswer(option.index);
            }
          }}
          data-testid={`option-card-${option.index}`}
        >
          <div className="key-cap">{option.index + 1}</div>
          <span>{option.text}</span>
        </div>
      ))}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '24px' }}>
        <button className="text-link" onClick={onBack} data-testid="back-button">
          &larr; Back
        </button>
        <span className="progress-count" data-testid="progress-counter">
          {questionIndex + 1} of {totalQuestions}
          <span className="hint-text" style={{ marginLeft: '8px' }}>[{question.item_id}]</span>
        </span>
        <button
          className="text-link"
          onClick={onRewindSection}
          data-testid="rewind-section-btn"
        >
          Rewind Section
        </button>
      </div>

      {typeof window !== 'undefined' && window.innerWidth > 768 && (
        <div className="hint-text" style={{ textAlign: 'center', marginTop: '8px' }}>
          Press 1-4 to select, Enter to continue
        </div>
      )}
    </div>
  );
}
